<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">
        MOH 511 - CHILD WELFARE CLINIC (CWC) REGISTER
      </div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total CWC Visits</span>
        <span class="stat-number">{{ totalVisits }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Children Under 1 Year</span>
        <span class="stat-number">{{ underOneYear }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Growth Monitoring</span>
        <span class="stat-number">{{ growthMonitored }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Vit A Supplemented</span>
        <span class="stat-number">{{ vitaminASupplemented }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="cwc-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">Date</th>
            <th rowspan="2">CWC No</th>
            <th rowspan="2">Child's Name</th>
            <th rowspan="2">Date of Birth</th>
            <th rowspan="2">Age (months)</th>
            <th rowspan="2">Sex</th>
            <th rowspan="2">Mother/Caregiver</th>
            <th rowspan="2">Contact</th>
            <th rowspan="2">SubLocation</th>
            <th colspan="3">Growth Monitoring</th>
            <th colspan="2">Nutrition</th>
            <th colspan="4">Developmental Milestones</th>
            <th rowspan="2">Immunizations Given</th>
            <th rowspan="2">Next Visit</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr class="sub-header">
            <th>Weight (kg)</th>
            <th>Height/Length (cm)</th>
            <th>MUAC (cm)</th>
            <th>Vit A Dose</th>
            <th>Nutrition Counselling</th>
            <th>Gross Motor</th>
            <th>Fine Motor</th>
            <th>Language</th>
            <th>Social</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.cwcNo }}</td>
            <td>{{ record.childName }}</td>
            <td>{{ record.dob }}</td>
            <td>{{ record.ageMonths }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.caregiver }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td class="text-center">{{ record.weight }}</td>
            <td class="text-center">{{ record.height }}</td>
            <td class="text-center">{{ record.muac }}</td>
            <td class="text-center">
              <span v-if="record.vitaminA" class="yes-badge">Given</span>
              <span v-else class="no-badge">Not Given</span>
            </td>
            <td class="text-center">
              <span v-if="record.nutritionCounselling" class="yes-badge"
                >Yes</span
              >
              <span v-else class="no-badge">No</span>
            </td>
            <td class="text-center">
              <span
                :class="{
                  achieved: record.grossMotor === 'Achieved',
                  'not-achieved': record.grossMotor === 'Not Achieved',
                }"
              >
                {{ record.grossMotor || "--" }}
              </span>
            </td>
            <td class="text-center">
              <span
                :class="{
                  achieved: record.fineMotor === 'Achieved',
                  'not-achieved': record.fineMotor === 'Not Achieved',
                }"
              >
                {{ record.fineMotor || "--" }}
              </span>
            </td>
            <td class="text-center">
              <span
                :class="{
                  achieved: record.language === 'Achieved',
                  'not-achieved': record.language === 'Not Achieved',
                }"
              >
                {{ record.language || "--" }}
              </span>
            </td>
            <td class="text-center">
              <span
                :class="{
                  achieved: record.social === 'Achieved',
                  'not-achieved': record.social === 'Not Achieved',
                }"
              >
                {{ record.social || "--" }}
              </span>
            </td>
            <td class="text-center">
              <span v-if="record.immunizations" class="yes-badge">{{
                record.immunizations
              }}</span>
              <span v-else class="no-badge">None</span>
            </td>
            <td>{{ record.nextVisit }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="23" class="empty-row">
              No CWC records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH511CWC",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      cwcRecords: [
        {
          date: "2026-04-22",
          cwcNo: "CWC001",
          childName: "Baby John Mwenda",
          dob: "2026-01-15",
          ageMonths: 3,
          sex: "M",
          caregiver: "Mary Mwenda",
          contact: "0712345678",
          subLocation: "Kianjai",
          weight: 5.6,
          height: 58,
          muac: 12.5,
          vitaminA: false,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "OPV1, DPT1, PCV1",
          nextVisit: "2026-05-22",
          remarks: "Growing well",
        },
        {
          date: "2026-04-22",
          cwcNo: "CWC002",
          childName: "Baby Grace Karimi",
          dob: "2025-10-10",
          ageMonths: 6,
          sex: "F",
          caregiver: "Jane Karimi",
          contact: "0723456789",
          subLocation: "Mutuati",
          weight: 7.2,
          height: 64,
          muac: 13.2,
          vitaminA: true,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "OPV3, DPT3, PCV3",
          nextVisit: "2026-05-22",
          remarks: "Vit A given",
        },
        {
          date: "2026-04-21",
          cwcNo: "CWC003",
          childName: "Baby Peter Kimathi",
          dob: "2025-08-05",
          ageMonths: 8,
          sex: "M",
          caregiver: "Alice Kimathi",
          contact: "0734567890",
          subLocation: "Kangeta",
          weight: 8.1,
          height: 70,
          muac: 13.8,
          vitaminA: true,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "MR 1",
          nextVisit: "2026-05-21",
          remarks: "Measles vaccine given",
        },
        {
          date: "2026-04-20",
          cwcNo: "CWC004",
          childName: "Baby Sarah Muthoni",
          dob: "2026-02-28",
          ageMonths: 1.5,
          sex: "F",
          caregiver: "Grace Muthoni",
          contact: "0745678901",
          subLocation: "Laare",
          weight: 4.2,
          height: 52,
          muac: 10.5,
          vitaminA: false,
          nutritionCounselling: true,
          grossMotor: "Not Achieved",
          fineMotor: "Not Achieved",
          language: "Not Achieved",
          social: "Achieved",
          immunizations: "BCG, OPV0",
          nextVisit: "2026-05-20",
          remarks: "First CWC visit",
        },
        {
          date: "2026-04-19",
          cwcNo: "CWC005",
          childName: "Baby James Mwirigi",
          dob: "2025-11-15",
          ageMonths: 5,
          sex: "M",
          caregiver: "Lucy Mwirigi",
          contact: "0756789012",
          subLocation: "Kianjai",
          weight: 6.8,
          height: 62,
          muac: 12.8,
          vitaminA: false,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "OPV2, DPT2, PCV2",
          nextVisit: "2026-05-19",
          remarks: "Defaulted previous appointment",
        },
        {
          date: "2026-04-18",
          cwcNo: "CWC006",
          childName: "Baby Esther Kendi",
          dob: "2025-09-20",
          ageMonths: 7,
          sex: "F",
          caregiver: "Ruth Kendi",
          contact: "0767890123",
          subLocation: "Mutuati",
          weight: 7.5,
          height: 67,
          muac: 13.5,
          vitaminA: true,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "OPV3, DPT3, PCV3",
          nextVisit: "2026-05-18",
          remarks: "Vit A given",
        },
        {
          date: "2026-04-17",
          cwcNo: "CWC007",
          childName: "Baby Samuel Mutuma",
          dob: "2026-03-01",
          ageMonths: 1.5,
          sex: "M",
          caregiver: "Mercy Mutuma",
          contact: "0778901234",
          subLocation: "Kangeta",
          weight: 4.5,
          height: 54,
          muac: 11.0,
          vitaminA: false,
          nutritionCounselling: true,
          grossMotor: "Not Achieved",
          fineMotor: "Not Achieved",
          language: "Not Achieved",
          social: "Achieved",
          immunizations: "OPV1, DPT1, PCV1",
          nextVisit: "2026-05-17",
          remarks: "First visit",
        },
        {
          date: "2026-04-16",
          cwcNo: "CWC008",
          childName: "Baby Naomi Gacheri",
          dob: "2025-12-10",
          ageMonths: 4,
          sex: "F",
          caregiver: "Hannah Gacheri",
          contact: "0789012345",
          subLocation: "Laare",
          weight: 6.2,
          height: 60,
          muac: 12.2,
          vitaminA: false,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "OPV2, DPT2, PCV2",
          nextVisit: "2026-05-16",
          remarks: "Growing well",
        },
        {
          date: "2026-04-15",
          cwcNo: "CWC009",
          childName: "Baby Mercy Kajuju",
          dob: "2025-07-12",
          ageMonths: 9,
          sex: "F",
          caregiver: "Florence Kajuju",
          contact: "0790123456",
          subLocation: "Kianjai",
          weight: 8.5,
          height: 72,
          muac: 14.0,
          vitaminA: true,
          nutritionCounselling: true,
          grossMotor: "Achieved",
          fineMotor: "Achieved",
          language: "Achieved",
          social: "Achieved",
          immunizations: "MR 1, Vit A",
          nextVisit: "2026-05-15",
          remarks: "Well child",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.cwcRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }
      return filtered;
    },
    totalVisits() {
      return this.filteredRecords.length;
    },
    underOneYear() {
      return this.filteredRecords.filter((r) => r.ageMonths < 12).length;
    },
    growthMonitored() {
      return this.filteredRecords.filter((r) => r.weight && r.height).length;
    },
    vitaminASupplemented() {
      return this.filteredRecords.filter((r) => r.vitaminA).length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 160px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.cwc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1800px;
}

.cwc-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.cwc-table th.sub-header {
  background: #374151;
  font-size: 10px;
}

.cwc-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.cwc-table td.text-center {
  text-align: center;
}

.yes-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.no-badge {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.achieved {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.not-achieved {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .cwc-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .cwc-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .cwc-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }
}
</style>
